import { useEffect, useState } from "react";
import api, { money, installmentValue } from "@/lib/api";
import { Link } from "react-router-dom";
import { Smartphone, ArrowLeft, ShieldCheck, Star } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${BACKEND}${p}`);

export default function Seminovos() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/public/seminovos").then((r) => setData(r.data)).catch(() => setData({ devices: [] })); }, []);

  const wa = (d) => {
    const num = (data?.company?.whatsapp || "").replace(/\D/g, "");
    const tpl = data?.whatsapp_templates?.phone_interest || "Olá! Tenho interesse no {produto}.";
    const msg = tpl.replace("{produto}", `${d.brand || ""} ${d.name}`.trim());
    return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white">
      <header className="alpha-glass sticky top-0 z-30 h-16 flex items-center px-4 lg:px-8">
        <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-zinc-300 hover:text-white text-sm"><ArrowLeft size={16} />Voltar ao início</Link>
      </header>
      <main className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
        <h1 className="text-4xl sm:text-5xl font-display font-extrabold tracking-tight">Seminovos <span className="alpha-gold-text">garantidos</span></h1>
        <p className="text-zinc-400 mt-3 max-w-2xl">{data?.warranty_label ? `Todos com ${data.warranty_label}.` : ""} Aparelhos revisados, testados e prontos para uso.</p>

        {!data ? <p className="text-zinc-500 mt-10">Carregando…</p> : data.devices.length === 0 ? (
          <p className="text-zinc-500 mt-10" data-testid="seminovos-empty">Nenhum aparelho disponível no momento. Fale com a gente no WhatsApp!</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
            {data.devices.map((d) => (
              <div key={d.id} data-testid={`seminovo-${d.id}`} className="alpha-card overflow-hidden flex flex-col">
                <div className="aspect-square overflow-hidden bg-[#121217] relative">
                  {d.photos?.[0] ? (
                    <img src={imgUrl(d.photos[0])} alt={d.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-zinc-700"><Smartphone size={48} /></div>
                  )}
                  {d.featured && <span data-testid={`seminovo-featured-${d.id}`} className="absolute top-3 right-3 text-[11px] px-2.5 py-1 rounded-full bg-gold/90 text-black font-semibold flex items-center gap-1"><Star size={11} className="fill-black" />Destaque</span>}
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="text-lg font-semibold">{d.name}</div>
                  <div className="text-sm text-zinc-500 mt-1 flex items-center gap-2 flex-wrap">
                    {d.category && <span>{d.category}</span>}{d.brand && <span>· {d.brand}</span>}
                  </div>
                  {d.description && <p className="text-xs text-zinc-500 mt-2 line-clamp-2">{d.description}</p>}
                  <div className="mt-auto pt-5">
                    <div className="text-2xl font-mono-kpi font-extrabold alpha-gold-text">{money(d.price)}</div>
                    <p className="text-[11px] text-zinc-500 mt-0.5">ou {data.installments?.count || 12}x de {money(installmentValue(d.price, data.installments?.count, data.installments?.interest))} no cartão <span className="opacity-70">(simulação)</span></p>
                    <a href={wa(d)} target="_blank" rel="noreferrer" data-testid={`seminovo-wa-${d.id}`} className="mt-4 block text-center text-sm font-semibold text-black px-4 py-2.5 rounded-full" style={{ background: "linear-gradient(135deg,#F3C64F,#D4AF37 55%,#AA820A)" }}>Tenho interesse</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
